import { Component } from '@angular/core';
import {ICellRendererAngularComp} from "ag-grid-angular";
import {MatDialog} from "@angular/material/dialog";
import {ICellRendererParams} from "ag-grid-community";
import {Router} from "@angular/router";

import {isEmpty, isFunction, get} from 'lodash';

@Component({
    selector: 'lib-table-cell-name',
    templateUrl: './table-cell-name.component.html',
    styleUrls: ['./table-cell-name.component.scss'],
    standalone: false
})
export class TableCellNameComponent  implements ICellRendererAngularComp {

  cellParams: any;
  item: any;
  value: any;
  dialogRef: any;

  constructor(public dialogForm: MatDialog, private router: Router) {
  }

  agInit(params: ICellRendererParams): void {
    this.cellParams = params?.colDef?.cellRendererParams || {};
    this.item = params.data;
    this.value = params.value;
  }

  refresh(params: ICellRendererParams<any>): boolean {
    this.cellParams = params?.colDef?.cellRendererParams || {};
    this.item = params.data;
    this.value = params.value;
    return true;
  }

  get namePrefix(): { iconClass?: string; tooltip?: string } | null {
    const fn = this.cellParams?.getNamePrefix;
    if (typeof fn !== 'function') {
      return null;
    }
    const result = fn(this.item);
    if (!result?.show) {
      return null;
    }
    return result;
  }

  linkClicked(event) {
    event.stopPropagation();
    event.preventDefault();
    if (isFunction(this.cellParams?.cellNamePreCheck)) {
      this.cellParams?.cellNamePreCheck(this.item).then((result) => {
        if (!result?.confirmed) {
          return;
        }
        this.router.navigateByUrl(`${this.cellParams.pathRoot}/${get(this.item, this.cellParams.itemProp, this.item.id)}`);
      })
      return;
    }
    this.router.navigateByUrl(`${this.cellParams.pathRoot}/${get(this.item, this.cellParams.itemProp, this.item.id)}`);
  }

  get cellText() {
    let val = this.value;
    if (isEmpty(val)) {
      val = this.item.name;
    }
    return val;
  }
}
